import { connect } from "react-redux";
import DatePicker from 'react-datepicker';
import moment from "moment";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";

var DateSpans = require("lib/data/DateSpans");
var CurrentUser = require("lib/account/CurrentUser");

var SmartBookSearch = require("components/reading/books/SmartBookSearch");
var LoadingButton = require("components/utility/LoadingButton");

var ReadingSelectors = require('lib/selectors/ReadingSelectors');
var WritingSelectors = require('lib/selectors/WritingSelectors');

var ReadingActions = require("lib/actions/ReadingActions");
var WritingActions = require("lib/actions/WritingActions");

require("writing/activities/assign_activity_details_modal.scss");

@connect(
  (state, props) => ({
    getAssignedTitles: (student_id) => {
      return ReadingSelectors.assignedTitleBooks({ state, studentID: student_id });
    },
    getAssignedURLs: (student_id) => {
      return ReadingSelectors.assignedURLBooks({ state, studentID: student_id });
    },
    teacherPicks: WritingSelectors.teacherPicksTasks({ state })
  }),
  (dispatch, props) => ({
    populateData: () => {
      if (props.selectedUserIDs) {
        _.each(props.selectedUserIDs, (userID) => {
          dispatch(ReadingActions.fetchBookActivity({
            conditions: { userID: userID, allowDraft: true },
            cache: true, fetchDetails: true
          }));
        })
      }
    },
    createTaskAssignment: (userIDs, state, teacherPicks) => {
      // determine if teacher pick exists for this book
      var selectedBookId = state.selectedBook ? state.selectedBook.text_id : null
      // determine due date
      var due_date = state.due_date_enabled ? new Date(state.due_date) : null
      // build teacher pick task
      var bookTasks = _.map(userIDs, (studentID) => {
        var existingTeacherPick = _.where(teacherPicks, { user_id: studentID, subject_id: selectedBookId })
        var pick_exists = existingTeacherPick.length ? true : false
        return {
          user_id: studentID, assigner_id: CurrentUser.get().id,
          subject_type: 'TitlePick', subject_id: selectedBookId,
          due_date: due_date, text_id: selectedBookId, pick_exists: pick_exists
        };
      });
      // build query/task items for the book task
      var query = {
        task_items: {
          quiz: 0, practice_questions: 0,
          review: 0, due_date: due_date,
          due_date_enabled: state.due_date_enabled, exercises: 1,
          exercise_id: props.taskSubjectID
        }
      }
      // create the task item
      return dispatch(WritingActions.createTasks({ tasks: bookTasks, query: query }))
    }
  })
)
@providePopulateData()
class AssignExerciseDetailsModal extends React.Component {
  constructor(props) {
    super(props);
    autobind(this);

    var defaultDate = new Date();
    defaultDate.setDate(defaultDate.getDate() + 7);

    this.state = {
      loading: false,
      allAssignedBooks: [],
      selectedBook: null,
      due_date: defaultDate.toLocaleString(),
      due_date_enabled: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.submitActivity = this.submitActivity.bind(this);
  }

  submitActivity(e) {
    $wr.nope(e)
    this.setState({ loading: true });
    // update task items
    this.props.createTaskAssignment(this.props.selectedUserIDs, { ...this.state }, this.props.teacherPicks).then(() => {
      this.setState({ loading: false });
      var text = "The exercise has been updated"
      var title = "Exercise Updated";
      window.wrNotifications.triggerDropDownNotification({
        title: title, text: text, icon: "ok-sign"
      });
      this.props.onAssign();
    })
  }

  handleInputChange = event => {
    var target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    var name = target.name;

    this.setState({ [name]: value })
  }

  handleNoneInput = event => {
    this.setState({ none: true, quiz: false, review: false, practice_questions: false, due_date_enabled: false })
  }

  renderDatePicker = () => {
    var date_picker = ''
    if (this.state.due_date_enabled) {
      date_picker = (
        <span>
          <label>
            Due Date:
            <DatePicker data-lpignore="true" readOnly={true} selected={moment(this.state.due_date)}
              onChange={(date) => this.setState({ due_date: date.format(DateSpans.FORMAT) })} />
          </label>
          <br />
        </span>
      )
    }
    return date_picker
  }

  onBookSelect(book) {
    this.setState({ selectedBook: book });
  }

  renderCheckBoxes() {
    return (
      <div className={ 'dateCheckboxContainer' }>
        <label>
          Add Due Date:
          <input
            name='due_date_enabled'
            type="checkbox"
            checked={this.state.due_date_enabled}
            onChange={this.handleInputChange} />
        </label>
        <br />
        { this.renderDatePicker() }
      </div>
    );
  }
  // shows disclaimer if a book and due date is selected
  renderDisclaimer() {
    if (this.state.due_date_enabled && this.state.selectedBook) {
      return (
        <div className='activityDetailsNote'>
          Note: If a due date is applied to a Teacher Pick assignment for this same title, that due date will override the due date applied to this Exercise.
        </div>
      )
    }
  }

  render() {
    return (
      <form className="assignExerciseDetailsForm">
        {this.renderCheckBoxes()}
        <div className="bookSearchBox">
          <label>
            Assign to Book:
          </label>
          <SmartBookSearch selectedBook={this.state.selectedBook} onBookSelect={this.onBookSelect} />
          {this.renderDisclaimer()}
        </div>
        <br/>
        <LoadingButton className="btn buttonSuccess center-block"
          loading={this.state.loading} text={'Assign'}
          onClick={this.submitActivity} />
      </form>
    );
  }


};

AssignExerciseDetailsModal.WrappedComponent.propTypes = StrictPropTypes({
  // ID of the task we're assigning
  taskSubjectID: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,

  onAssign: PropTypes.func,
  selectedUserIDs: PropTypes.array,

  // subject type of the task we are assigning
  taskSubjectType: PropTypes.string.isRequired,

  getAssignedTitles: PropTypes.func,
  getAssignedURLs: PropTypes.func,
  selectedActivityTitle: PropTypes.string,
  createTaskItems: PropTypes.func,
  createTaskAssignment: PropTypes.func,
  buildActivityTask: PropTypes.func,
  populateData: PropTypes.func,
  fetchBookActivity: PropTypes.func,
  loadStudentData: PropTypes.func,
  books: PropTypes.array,
  teacherPicks: PropTypes.array,
  fetchBooks: PropTypes.func,
});

module.exports = AssignExerciseDetailsModal;



// WEBPACK FOOTER //
// ./modules/components/writing/activities/AssignExerciseDetailsModal.js